// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de formation historique, géographique, économique et sociale
// https://ifpc-fwb.be/v5/documents/tc/refFHGES.pdf
// SHA-256 71d50efd3a1683c56b8c09121777055e0b2711b3335eafe60487367da1f220f5
// P3: pages 119-121, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "FHGES-P3-f8c54722",
    champ: "",
    section: "Les mécanismes de la communication et de la publicité",
    kind: "Savoir",
    parent: "Biens/Services. Besoins/Envies.",
    text: "Exemplifier les notions de bien et de service.",
  },
  {
    id: "FHGES-P3-40aef757",
    champ: "",
    section: "Les mécanismes de la communication et de la publicité",
    kind: "Savoir",
    parent: "Biens/Services. Besoins/Envies.",
    text: "Exemplifier la différence entre un besoin et une envie. Citer des envies suscitées par des médias ou par les pairs.",
  },
  {
    id: "FHGES-P3-3dc113e8",
    champ: "",
    section: "Les mécanismes de la communication et de la publicité",
    kind: "Savoir",
    parent: "Déterminants économiques de la consommation : prix. Budget. Canaux de communication.",
    text: "Citer des besoins dont la satisfaction est liée à un prix/est gratuite. Identifier des supports de diffusion de la publicité.",
  },
  {
    id: "FHGES-P3-b0ed241c",
    champ: "",
    section: "Formation sociale",
    kind: "Savoir",
    parent: "La communication et le lien social",
    text: "Identifier dans un cas concret qui est l’émetteur (énonciateur) et qui est le récepteur (destinataire) d’un message.",
  },
  {
    id: "FHGES-P3-0bd1e13d",
    champ: "",
    section: "Formation sociale",
    kind: "Savoir",
    parent: "Communication interpersonnelle : émetteur (énonciateur), récepteur (destinataire), message, canal, rétroaction.",
    text: "Relater le contenu d’un message (ce qui a été dit, exprimé…) sans le transformer, l’interpréter ni le juger.",
  },
  {
    id: "FHGES-P3-e84964d2",
    champ: "",
    section: "Formation sociale",
    kind: "Savoir",
    parent: "Échanges.",
    text: "Identifier différents canaux de communication.",
  },
  {
    id: "FHGES-P3-c315dd76",
    champ: "",
    section: "Formation sociale",
    kind: "Savoir",
    parent: "Échanges.",
    text: "Exemplifier différents types de rétroaction dans le cadre d’un échange interpersonnel.",
  },
  {
    id: "FHGES-P3-5d1fe986",
    champ: "",
    section: "Formation économique et sociale",
    kind: "Savoir-faire",
    parent: "Collecter et/ou extraire des informations économiques et sociales.",
    text: "Rechercher et comparer le prix d’un même bien/service sur différents supports et dans différents lieux de vente. Identifier des envies considérées comme féminines et masculines en comparant des publicités, par exemple, d’époques différentes.",
  },
  {
    id: "FHGES-P3-520651b5",
    champ: "",
    section: "Formation économique et sociale",
    kind: "Savoir-faire",
    parent: "Analyser des informations à l’aide d’outils variés spécifiques des sciences économiques et sociales.",
    text: "Identifier dans une publicité les éléments suivants : média, public cible, bien/service visé et besoin rencontré/ envie suscitée.",
  },
  {
    id: "FHGES-P3-ce5f39a9",
    champ: "",
    section: "Formation économique et sociale",
    kind: "Savoir-faire",
    parent: "Analyser des informations à l’aide d’outils variés spécifiques des sciences économiques et sociales.",
    text: "Au départ d’un cas concret, identifier un déficit dans la façon dont la communication s’est déroulée.",
  },
  {
    id: "FHGES-P3-2aae6562",
    champ: "",
    section: "Formation économique et sociale",
    kind: "Compétence",
    parent: "Formuler des hypothèses.",
    text: "Formuler une explication possible au fait qu’une publicité peut entrainer ou non un changement de comportement. Réaliser une publicité et formuler un argument quant à l’efficacité d’un procédé mis en place.",
  },
  {
    id: "FHGES-P3-5594c4b9",
    champ: "",
    section: "Formation économique et sociale",
    kind: "Compétence",
    parent: "Formuler un avis argumenté sur une question économique et sociale, en s’appuyant sur les concepts abordés.",
    text: "Au départ d’un cas concret présentant un déficit de communication, proposer une amélioration (choix du canal, rétroaction, précision de message).",
  },
];
